import { NavLink } from 'react-router-dom'
import { 
  TbRoute,
  TbBus,
  TbMapPin,
  TbSpeakerphone,
  TbUsers
} from 'react-icons/tb'
import styles from './MobileNavigation.module.css'
import { useCity } from '../../contexts/CityContext'
import { useAuth } from '../../contexts/AuthContext'

function MobileNavigation() {
  const { currentCity } = useCity();
  const { isLoggedIn } = useAuth();
  
  // Şehir seçilmediğinde veya şehir özellikleri mevcut değilse
  if (!currentCity) {
    return null;
  }

  return (
    <nav className={styles.mobileNav}>
      <div className={styles.navLinksContainer}>
        {/* Yol tarifi menü öğesi (routePlanning true ise göster) */}
        {currentCity.routePlanning && (
          <NavLink
            to="/directions"
            className={({ isActive }) => isActive ? styles.activeLink : styles.navLink}
            data-glow
          >
            <TbRoute className={styles.icon} />
            <span>Yol Tarifi</span>
          </NavLink>
        )}
        
        <NavLink
          to="/lines"
          className={({ isActive }) => isActive ? styles.activeLink : styles.navLink}
          data-glow
        >
          <TbBus className={styles.icon} />
          <span>Hatlar</span>
        </NavLink>
        
        <NavLink
          to="/stops"
          className={({ isActive }) => isActive ? styles.activeLink : styles.navLink}
          data-glow
        >
          <TbMapPin className={styles.icon} />
          <span>Duraklar</span>
        </NavLink>
        
        {/* Duyurular menü öğesi (announcements true ise göster) */}
        {currentCity.announcements && (
          <NavLink
            to="/announcements"
            className={({ isActive }) => isActive ? styles.activeLink : styles.navLink}
            data-glow
          >
            <TbSpeakerphone className={styles.icon} />
            <span>Duyurular</span>
          </NavLink>
        )}

        {isLoggedIn && (
          <NavLink
            to="/community"
            className={({ isActive }) => isActive ? styles.activeLink : styles.navLink}
            data-glow
          >
            <TbUsers className={styles.icon} />
            <span>Topluluk</span>
          </NavLink>
        )}
        
  {/* Ayarlar menü öğesi kaldırıldı */}
      </div>
    </nav>
  )
}

export default MobileNavigation
